import hr from '@src/service/i18n/numeral/hr';
import sl from '@src/service/i18n/numeral/sl';

export const NUMERAL_LOCALES = {
  hr,
  sl,
} as any;
